// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3CqE7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1-9US"};